module.exports = __webpack_public_path__ + "img/24080b9a6d9366fb4347d6f930187cf4.25df06e0.jpg";